import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { LayoutService } from '../../services/layout.service';
import { ChangePasswordRequest } from 'src/app/core/models/models';
import { take } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { AuthFactoryService } from 'src/app/auth/authFactory.service';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ChangePasswordComponent implements OnInit {
  open$: Observable<boolean>;
  form: FormGroup;

  constructor(
    private formBuilder: FormBuilder,
    private service: LayoutService,
    private authFactoryService: AuthFactoryService
  ) {}

  ngOnInit() {
    this.open$ = this.service.getOpenChangePassword();
    this.form = this.formBuilder.group(
      {
        old: ['', [Validators.required]],
        new: [
          '',
          [
            Validators.required,
            Validators.pattern('^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!.=+_@$%^&*-]).{8,}$')
          ]
        ],
        confirm: ['', [Validators.required]],
        userLoggedId: []
      },
      { validators: this.isEqual('new', 'confirm') }
    );
  }

  isEqual(newPassword: string, confirmPassword: string) {
    return (group: FormGroup) => {
      const pass1 = group.controls[newPassword].value;
      const pass2 = group.controls[confirmPassword].value;
      if (pass1 === pass2) {
        return null;
      }
      return { differentPassword: true };
    };
  }

  openModal(value: boolean) {
    this.service.dispatchOpenChangePassword(value);
  }

  submit() {
    if (this.form.valid) {
      this.service.dispatchChangePassword(this.buildRequest());
      this.form.reset();
    }
  }

  buildRequest(): ChangePasswordRequest {
    let userId: string;
    this.service
      .getUser()
      .pipe(take(1))
      .subscribe((user) => (userId = user.id));

    return {
      userId,
      oldPassword: this.form.value.old,
      newPassword: this.form.value.new,
      userLoggedId: this.authFactoryService.getUser().id
    };
  }
}
